import React, { Component } from 'react';

class Title extends Component {
    constructor(props) {
        super(props);
    }
    
    //TITULO
    render () {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>{this.props.titulo}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label className="label-primary">Recuerde que la nueva empresa se creará solo si efectivamente la selecciona para dar de alta tarjetas y la solicitud en conjunto es aprobada.</label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Title